<template>
  <div class="history">
    <div style="padding: 0px 20px;">
      <div class="search">
        <div class="search_box">
          <div  class="search_options_box">
            <span style="width: 100px;">{{search[0].title}}</span>
            <el-select class="select" v-model="selectProjectValue" placeholder="请选择项目" @change="getSelectTeam(selectProjectValue )">
              <el-option v-for="item in search[0].options" :label="item.label" :value="item.value" :key="item.value"></el-option>
            </el-select>
          </div>
          <div  class="search_options_box">
            <span style="width: 100px;">{{search[1].title}}</span>
            <el-select class="select" v-model="selectTeamValue" placeholder="请选择群组" @change="getSelectWork(selectTeamValue )">
              <el-option v-for="item in search[1].options" :label="item.label" :value="item.value" :key="item.value"></el-option>
            </el-select>
          </div>
          <div  class="search_options_box">
            <span style="width: 100px;">{{search[2].title}}</span>
            <el-select class="select" v-model="selectWorkValue" placeholder="请选择小组" >
              <el-option v-for="item in search[2].options" :label="item.label" :value="item.value" :key="item.value"></el-option>
            </el-select>
          </div>
          <div class="search_options_box">
            <span style="width: auto;white-space: nowrap">灯杆编号</span>
            <input type="text" id="number" style="width: calc(100% - 72px);" placeholder="请输入灯杆编号" v-model="lamppostid">
          </div>
          <div class="search_options_box">
            <span style="width: auto;white-space: nowrap">选择时间</span>
            <el-date-picker
              v-model="choiceDate"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="     选择日期">
            </el-date-picker>
          </div>
          <div class="search_btn_box">
            <button :class='["search_btn","green","icon_btn","clearborder"]' @click="GetList()"><span class="el-icon-search"></span>搜索</button>
          </div>
        </div>
      </div>

      <!--        表格-->
      <div class="table_content">
        <table>
          <thead>
          <tr>
            <th>上报时间</th>
            <th>灯杆编号</th>
            <th>地理位置</th>
            <th>实时电压(V)</th>
            <th>实时电流(A)</th>
            <th>实时功率因数</th>
            <th>实时有功功率(W)</th>
            <th>耗电量(KWh)</th>
            <th>亮灯状态</th>
            <th>故障状态</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item,index) in historyData" :key="index">
            <td>{{item.create_datetime}}</td>
            <td>{{item.lamppost}}</td>
            <td>{{item.site}}</td>
            <td>{{item.voltage}}</td>
            <td>{{item.current}}</td>
            <td>{{item.power_factor}}</td>
            <td>{{item.active_power}}</td>
            <td>{{item.cumulative_power}}</td>
            <td v-if="item.status='0'">关闭</td>
            <td v-else>开启</td>
            <td v-if="item.fault=='0'">正常</td>
            <td v-if="item.fault=='1'">异常亮灯</td>
            <td v-if="item.fault=='2'">异常关灯</td>
            <td v-if="item.fault=='3'">线路过流</td>
            <td v-if="item.fault=='4'">线路欠流</td>
            <td v-if="item.fault=='5'">线路过压</td>
            <td v-if="item.fault=='6'">线路欠压</td>
            <td v-if="item.fault=='7'">线路断电</td>
            <td v-if="item.fault=='8'">线路缺相</td>
            <td v-if="item.fault=='9'">线路漏电</td>
            <td v-if="item.fault=='10'">功率因数超限</td>
            <td v-if="item.fault=='11'">柜门开启</td>
            <td v-if="item.fault=='12'">配电柜倾斜</td>
            <td v-if="item.fault=='13'">配电柜进水</td>
            <td v-if="item.fault=='14'">配电柜雷击</td>
            <td v-if="item.fault=='15'">手自动切换</td>
            <td v-if="item.fault=='16'">外部控制器</td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="table_paging">
        <p>当前记录<span>{{(this.currentPage-1)*9+1}}</span>到<span>{{(this.currentPage-1)*9+this.historyData.length}}</span>条，共<span>{{this.totalPage}}</span>条记录
          <button @click="FirstPage()"
            v-bind:style="[{background:'url(/static/img/icon/table_start.png) no-repeat center center'}]"></button>
          <button
            @click="prevPage()" v-bind:style="[{background:'url(/static/img/icon/table_prep.png) no-repeat center center'}]"></button>
          第<span>{{currentPage}}</span>/<span>{{Math.ceil(totalPage/pageSize)}}</span>页
          <button
            @click="nextPage()" v-bind:style="[{background:'url(/static/img/icon/table_next.png) no-repeat center center'}]"></button>
          <button @click="LastPage()"
            v-bind:style="[{background:'url(/static/img/icon/table_end.png) no-repeat center center'}]"></button>
        </p>
      </div>

    </div>
  </div>
</template>

<script>
  export default {
    name: "history",
    data() {
      return {
        search: [
          {
            title: '选择项目',
            options: [],
          }, {
            title: '选择群组',
            options: [],
          }, {
            title: '选择小组',
            options: [],
          },
        ],
        projectList:[],
        choiceDate:'',
        lamppostid:'',
        teamList:[],
        workList:[],
        selectProjectValue:'17e3b71e-b460-498e-b0ef-657d20bd6549',
        selectTeamValue:'',
        selectWorkValue:'',
        //分页
        totalPage:'', // 统共页数，默认为1
        currentPage: 1, //当前页数 ，默认为1
        pageSize: 9, // 每页显示数量
        historyData: [],
        //搜索缓存
        SearchData:[
          {data:""},
          {data:""},
          {data:""},
          {data:""},
          {data:""},
        ],
        SearchDataClick:false
      }
    },
    mounted() {
      // 计算一共有几页
      this.getCurrentPageData();
    },
    methods: {
      InitLeftMenu:function () {
        this.$emit('getMessage', '0','2');
      },
      // 设置当前页面数据，对数组操作的截取规则为[0~9],[10~20]...,
      // 当currentPage为1时，我们显示(0*pageSize+1)-1*pageSize，当currentPage为2时，我们显示(1*pageSize+1)-2*pageSize...
      getCurrentPageData() {
        // let begin = (this.currentPage - 1) * this.pageSize;
        // let end = this.currentPage * this.pageSize;
        // this.currentPageData = this.tabledata.slice(
        //   begin,
        //   end
        // );
      },


      //获取小组列表
      getSelectWork:function(id){
        fetch("/api/v1/controller/list", {
          method: 'post',
          body: JSON.stringify({
            "groups_id":id,
            "page_size":10,
            "page_start":0,
          })
        })
          .then(result => {
            return result.json();//解析流
          })
          //.then(data => console.log(data))
          .then(data => {
            if (data.code == "200") {
              this.message = "小组数据获取成功";
              this.search[2].options=[];
              this.workList = data.data;
              let options = this.search[2].options;
              for (let i=0;i<this.workList.length;i++){
                let projectObj = {};
                projectObj.label = this.workList[i].name;
                projectObj.value = this.workList[i].id;
                options.push(projectObj);
              };
            } else {
              this.message = "数据更新异常，请重试";
            }
          })
          .catch((error) => {
            this.message = "网络异常，请重试";
            this.msg_show = !this.msg_show;
          });
      },



      //获取群组列表
      getSelectTeam:function(id){
        fetch("/api/v1/groups/list", {
          method: 'post',
          body: JSON.stringify({
            "project_id":id,
            "page_size":10,
            "page_start":0,
          })
        })
          .then(result => {
            return result.json();//解析流
          })
          //.then(data => console.log(data))
          .then(data => {
            if (data.code == "200") {
              this.message = "群组数据获取成功";
              this.search[1].options=[];
              this.search[2].options=[];
              this.teamList = data.data;
              let options = this.search[1].options;
              for (let i=0;i<this.teamList.length;i++){
                let projectObj = {};
                projectObj.label = this.teamList[i].name;
                projectObj.value = this.teamList[i].id;
                options.push(projectObj);
              };
            } else {
              this.message = "数据更新异常，请重试";
            }
          })
          .catch((error) => {
            this.message = "网络异常，请重试";
            this.msg_show = !this.msg_show;
          });
      },


      //获取项目列表
      getProjectList:function(){
        fetch("/api/v1/project/list", {
          method: 'post',
          body: JSON.stringify({

          })
        })
          .then(result => {
            return result.json();//解析流
          })
          //.then(data => console.log(data))
          .then(data => {
            if (data.code == "200") {
              this.message = "项目数据获取成功";
              this.projectList = data.data;
              let options = this.search[0].options;
              for (let i=0;i<this.projectList.length;i++){
                let projectObj = {};
                projectObj.label = this.projectList[i].name;
                projectObj.value = this.projectList[i].id;
                options.push(projectObj);
              };
            } else {
              this.message = "数据更新异常，请重试";
            }
          })
          .catch((error) => {
            this.message = "网络异常，请重试";
            this.msg_show = !this.msg_show;
          });
      },


      GetList(){
        fetch('/api/v1/lamp/record/list',{
          method:'post',
          body:JSON.stringify({
            project_id: this.selectProjectValue,
            groups_id: this.selectTeamValue,
            controller_id : this.selectWorkValue,
            lamppost_id :this.lamppostid,
            search_date : this.choiceDate,
            page_start: this.currentPage-1,
            page_size: "9",
          })
        }).then(result => {
          return result.json();
        }).then(data => {
          this.totalPage = data.total_count;
          this.historyData = data.data;
          this.selectProjectValue='';
          this.selectTeamValue='';
          this.selectWorkValue='';
        });
      },
      //上一页
      prevPage() {
        if (this.SearchDataClick===true){

        } else {
          if (this.currentPage == 1) {
            return false;
          } else {
            this.currentPage--;
            this.GetList();
          }
        }

      },
      // 下一页
      nextPage() {
        if (this.SearchDataClick===true){
        } else {
          if (this.currentPage == Math.ceil(this.totalPage/this.pageSize)) {
            return false;
          } else {
            this.currentPage++;
            this.GetList();
          }
        }

      },
      FirstPage(){
        if (this.SearchDataClick===true){

        } else {
          this.currentPage = 1;
          this.GetList();
        }
      },
      LastPage(){
        if (this.SearchDataClick===true){

        } else {
          this.currentPage = Math.ceil(this.totalPage/this.pageSize);
          this.GetList();
        }
      },
      //搜索
      // SearchDataSbt(){
      //   this.SearchDataClick=true
      // }
    },
    created(){
      this.InitLeftMenu();
      this.GetList();
      this.getProjectList();
    }
  }
</script>

<style scoped>
  .history {
    width: 100%;
    height: 100%;
  }

  .table_content {
    width: 100%;
    height: calc(100% - 100px);
    padding: 20px 0px;
  }

  .table_content > table {
    width: 100%;
    height: 100%;
    border: 1px solid #094b8e;
    background-color: #16518d;
  }

  .table_content > table tr th {
    background-color: #0e345b;
  }

  .table_content > table tr td {
    /*background-color: #16518d;*/
  }

  .table_content > table tr td input {
    width: 16px;
    height: 16px;

  }

  .table_content > table tr:nth-child(2n) {
    background-color: #11406f;
  }

  .table_content > table tr {
    /*border-bottom: 1px solid #225892;*/
    height: 62px
  }

  .table_content > table tr td, .table_content > table tr th {
    text-align: center;
    color: #FFFFFF;
  }

  .table_paging {
    height: 60px;
    width: 100%;
    display: flex;
    align-items: center;
    border: 1px solid #105ba8;
    border-radius: 6px;
  }

  .table_paging > p {
    width: 100%;
    height: 30px;
    line-height: 30px;
    text-align: right;
    margin-bottom: 0;
    color: #c1c2c6;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-right: 10px;
  }

  .table_paging > p > button {
    margin: 0 8px;
    width: 10px;
    height: 16px;
    border: none;
    outline: none;
  }


  .table_btn {
    color: #95bee5;
    background: transparent;
    border: 1px solid #95bee5;
    outline: transparent;
    padding: 5px 10px;
    border-radius: 6px;
  }
</style>



// WEBPACK FOOTER //
// src/components/03Monitoring/1_lamp/history.vue